import { CurrencyPipe } from "@angular/common";
import { CommonService } from "../services";

export interface AnnuityViewModel {
  annuityId: string;
  endUserName: string;
  programType: string;
  programDescription: string;
  currCustomerRef: string;
  nextCustomerRef: string;
  startDate: string;
  expiryDate: string;
  anniversaryDate?: string;
  billingDate: string;
  totalAmount: string;
  frequency: string;
  status: string;
  nextOrderNo: string;
  nextOrderSuffix: string;
  detailsView: string;
  invoiceDate: string;
  containUsage: string;
  programLogo: string;
  programName: string;
  priceLoadingStatus: boolean;
  vendorAgreementNo: string;
  lastBillingDate: string;
  lastBillingAmount: string;
  contractType: string;
  hasPaymentSetup: boolean;
  migrationInProgress: boolean;
  migrationCompleted: boolean;
  containsLegacy: string;
  euPortalAccess: boolean;
  autoRenew: string;
  pendingTransactions: string;
  openRenewal: string;
  isAMPPendingTransaction: boolean;
  customerPaymentNumber?: string;
}

export interface AnnuityListViewModel {
  orders: AnnuityViewModel[];
  detailsView: string;
  programType: string;
  programDescription: string;
  longDescription: string;
  programLogo: string;
  moreInfo: string;
}

export interface AnnuityTypeDetails {
  id: string;
  programType: string;
  salesType: string;
  shortDescription: string;
  longDescription: string;
  logo: string;
  moreInfoLink: string;
  detailsView: string;
  companyCode: string;
  isActive?: boolean;
  dateCreated: string;
  isAnnuityEmailSent?: boolean;
  emailLogo: string;
  ddteamEmail: string;
  programContactEmail: string;
  customerField1: string;
  isTestEmail?: boolean;
}
export interface I_AnnuityItemsViewModel {
  programType: string;
  lineType: string;
  annuityId: string;
  orderNo: string;
  orderSuffix: string;
  lineSequence: string;
  minQty: string;
  maxQty: string;
  billingFrequency: string;
  billingFrequencyDesc: string;
  isExisting: boolean;
  quantity: string;
  stockCode: string;
  description: string;
  itemPrice: string;
  itemRRPrice: string;
  chargeType: string;
  stockGroup: string;
  offerId: string;
  attestationRequired: boolean;
  isAddon: boolean;
  secondary_Category: string;
  tertiary_Category: string;
}

export class AnnuityItemsViewModel implements I_AnnuityItemsViewModel {
  programType: string;
  lineType: string;
  annuityId: string;
  orderNo: string;
  orderSuffix: string;
  lineSequence: string;
  minQty: string;
  maxQty: string;
  billingFrequency: string;
  billingFrequencyDesc: string;
  isExisting: boolean;
  quantity: string;
  stockCode: string;
  description: string;
  itemPrice: string;
  itemRRPrice: string;
  chargeType: string;
  stockGroup: string;
  offerId: string;
  attestationRequired: boolean;
  isAddon: boolean;
  secondary_Category: string;
  tertiary_Category: string;

  subscriptionDescription?: string;
  term?: string;
  mpn?: string;
  totalPrice?: number;
  itemPriceByBF?: string;
  itemPriceByBFUnit?: string;
  isDisabled?: boolean;
  isAdded?: boolean;
  disableQty?: boolean;
  minMaxQtyText?: string;
  ownerEmail?: string;
  ownerEmailStatus?: boolean;
  editMPN?: boolean;
  editBillingFrequency?: boolean;
  editTerm?: boolean;
  defaultBillingFreq?: string;
  supportedFamilyProductStockCodes?: string[];
  supportedBillingCycleTypes?: string[];
  supportedTermsForChange?: string[];
  qualification?: string;
  effectiveDate?: string;

  constructor(data: I_AnnuityItemsViewModel) {
    Object.assign(this, data);
  };

  populateProductFamilyData(
    productPool: AnnuityItemsViewModel[],
    cs: CommonService,
    cp: CurrencyPipe
  ) {
    const stockCode0 = this.stockCode.split(':')[0];
    const stockCode1 = this.stockCode.split(':')[1];
    const stockCode2 = this.stockCode.split(':')[2];
    const stockCode3 = this.stockCode.split(':')[3];

    this.supportedFamilyProductStockCodes = productPool
      .filter(x => `${x.stockCode.split(':')[1]}:${x.stockCode.split(':')[2]}` == `${stockCode1}:${stockCode2}`)
      .map(x => x.stockCode);

    this.supportedTermsForChange = this.supportedFamilyProductStockCodes
      .map(x => x.split(':')[0])
      .filter((value, index, array) => array.indexOf(value) === index); // distinct 

    this.supportedBillingCycleTypes = this.supportedFamilyProductStockCodes
      .filter(x => `${x.split(':')[0]}:${x.split(':')[1]}:${x.split(':')[2]}` == `${stockCode0}:${stockCode1}:${stockCode2}`)
      .map(x => x.split(':')[3])

    this.term = stockCode0;
    this.billingFrequency = stockCode3;

    switch (stockCode3) {
      case "1":
        this.itemPriceByBFUnit = '/mth';
        break;
      case "Y":
        this.itemPriceByBFUnit = '/yr';
        break;
      case "T":
        this.itemPriceByBFUnit = '/3yr';
        break;
    }

    if (this.needToAdjustPrice()) {
      const year = cs.extractCSPSKUYearNumber(this.stockCode)
      const monthlyPrice = cs.toNumber(this.itemPrice.replace('$', '').replace(',', '')) / (12 * year)
      this.itemPriceByBF = cp.transform(
        this.billingFrequency == '1' ? monthlyPrice : monthlyPrice * 12,
        'AUD',
        'symbol-narrow',
        '.2-2'
      );
      // this.itemPriceByBFUnit = this.billingFrequency == '1' ? '/mth' : '/yr';
      this.totalPrice = cs.toNumber(this.itemPriceByBF.replace('$', '').replace(',', '')) * cs.toNumber(this.quantity);
    } else {
      this.itemPriceByBF = '';
      // this.itemPriceByBFUnit = '';
      this.totalPrice = cs.toNumber(this.itemPrice.replace('$', '').replace(',', '')) * cs.toNumber(this.quantity);
    }
  }
  
  needToAdjustPrice(): boolean {
    const term = this.stockCode.split(':')[0];
    return (term != 'P1M' && this.billingFrequency == '1') ||
      (term == 'P3Y' && this.billingFrequency == 'Y');
  }
}